import React from "react"
import {Button} from "@material-tailwind/react";
import {useNavigate} from "react-router-dom";


const BeforeLogin = () => {

    const navigate = useNavigate();
    return(
        <div className={"flex flex-col items-center justify-center gap-6 h-full"}>
            <h1 className={"font-bold text-blue-800"}>
                welcome to Yummy food application
            </h1>

            <p className={"font-thin"}>
                Go to the next step to view the healthy meal
            </p>

            <Button  onClick={()=>navigate("/chat")}>
                Start chat with yummy
            </Button>
        </div>
    )
}


export default BeforeLogin;